import styled, { css } from 'styled-components';
import { PortalModal } from 'web-app/react/components/modals/modals';
export const StyledModalPortalWidth = {
    Medium: '450px',
    Big: '600px',
};
export const StyledModalPortal = styled(PortalModal) `
    ${props => props.width
    ? css `
                  width: ${props.width};
              `
    : ''}
    ${props => props.maxWidth
    ? css `
                  max-width: ${props.maxWidth};
              `
    : ''}
    ${props => props.height
    ? css `
                  height: ${props.height};
              `
    : ''}
    ${props => props.margin
    ? css `
                  margin: ${props.margin};
              `
    : ''}
    ${props => props.borderRadius
    ? css `
                  border-radius: ${props.borderRadius};
              `
    : ''}

    ${props => props.backgroundColor
    ? css `
                  background-color: ${props.theme.mf.colorPalette[props.backgroundColor]};
              `
    : ''}
`;
